export const PHNX_STAKING_ADDRESS =
  // Staking V1.1 mainnet
  "0x4792b51b474C158ae40EA2a05B743441ca068f24";

// "0xFa70F492D9f4fc28C8D6b9e65eac0B0AA363AF7F";

// I DEPLOYED THIS CONTRACT ON RINKEBY BELOW ONE
// "0xEDaf1C09afAD2a42aE24c3A30676edaE3660901C";

// address by musfira
// "0xc53E8ab88a91d16A669Fd5D2ADA12807125194f5";

// address new Rinkbey Danial ansari
// "0x169b752134c23634D4f6E4a73a2bCEcaF8D2032F";

//address new rinkbey Arun 1
// "0x2B10332ca66d8246B882e5F889Af287C013910ba";

//address rinkbey new Arun 2
// "0x84d67a74A2bfCDD05d11ebA99cCC6aDdFC0Ccd7B";

// new staking ABI

export const PHNX_STAKING_ABI = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newRate",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_oldRate",
        type: "uint256",
      },
    ],
    name: "BaseInterestUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_oldQuanitity",
        type: "uint256",
      },
    ],
    name: "QuantityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "stakeID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "altQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initiationTimestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "durationTimestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "phnxContractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "portalAddress",
        type: "address",
      },
    ],
    name: "StakeCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newdays",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_oldDays",
        type: "uint256",
      },
    ],
    name: "StakeDaysUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "stakeID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "stakedToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "portalAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "altQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "durationTimestamp",
        type: "uint256",
      },
    ],
    name: "Unstake",
    type: "event",
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SECONDS_IN_ONE_YEAR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalrewardTokens",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxStakedQuantity",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "phnxContractAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ratio",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_altQuantity", type: "uint256" },
      { internalType: "uint256", name: "_time", type: "uint256" },
    ],
    name: "stakeALT",
    outputs: [
      { internalType: "uint256", name: "rewardAmount", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_altQuantity", type: "uint256" },
      { internalType: "uint256", name: "_time", type: "uint256" },
      { internalType: "address", name: "_beneficiary", type: "address" },
    ],
    name: "stakeFor",
    outputs: [
      { internalType: "uint256", name: "rewardAmount", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakeTime",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "stakerBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "stakerData",
    outputs: [
      { internalType: "uint256", name: "altQuantity", type: "uint256" },
      { internalType: "uint256", name: "initiationTimestamp", type: "uint256" },
      { internalType: "uint256", name: "durationTimestamp", type: "uint256" },
      { internalType: "uint256", name: "rewardAmount", type: "uint256" },
      { internalType: "address", name: "staker", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStakedTokens",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_expiredStakeIds",
        type: "bytes32[]",
      },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "unstakeALT",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_quantity", type: "uint256" }],
    name: "updateQuantity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_rate", type: "uint256" }],
    name: "updateRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_stakeTime", type: "uint256" }],
    name: "updatestakeDays",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
